import { images, startLinkProps } from '../data';

export default function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="hero-media">
        <img
          src={images.hero}
          alt="Balanced stones overlooking a misty landscape"
          width="1024"
          height="682"
          fetchPriority="high"
          decoding="async"
        />
        <div className="hero-scrim" aria-hidden="true" />
        <div className="hero-inner container">
          <div className="hero-copy">
            <h1 id="hero-heading">
              Bookkeeping &amp; payroll
              <br />
              for <em>service businesses.</em>
            </h1>
            <p className="hero-lede">
              Accurate, reliable financial support for small service businesses and independent
              professionals.
            </p>
            <div className="hero-actions">
              <a className="btn btn-gold" {...startLinkProps}>
                Schedule a call
              </a>
            </div>
          </div>

          <div className="hero-seal" role="img" aria-label="30-day 100% satisfaction guarantee">
            <span className="hero-seal-face" aria-hidden="true">
              <span className="hero-seal-star">★</span>
              <strong className="hero-seal-headline">30-Day</strong>
              <span className="hero-seal-rule" />
              <span className="hero-seal-sub">100% Satisfaction</span>
              <span className="hero-seal-sub">Guarantee</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
